import { RARE_BURST_LETTERS } from './formulas'
import { GLOBAL } from '../config/global'

export interface LetterMastery {
  wordsUsed: string[]
  milestoneLexicographer: boolean
  milestoneLengthy: boolean
  milestoneRaritySeeker: boolean
  milestoneChainLink: boolean
  milestoneSwift: boolean
}

export function newMastery(): LetterMastery {
  return {
    wordsUsed: [],
    milestoneLexicographer: false,
    milestoneLengthy: false,
    milestoneRaritySeeker: false,
    milestoneChainLink: false,
    milestoneSwift: false,
  }
}

function countRare(word: string): number {
  let n = 0
  for (const ch of word.toUpperCase()) if (RARE_BURST_LETTERS.has(ch)) n++
  return n
}

export function updateMastery(
  current: LetterMastery,
  word: string,
  chainLength: number,
  timeSinceLastBurstSec: number | null,
): LetterMastery {
  const upper = word.toUpperCase()
  const wordsUsed = current.wordsUsed.includes(upper)
    ? current.wordsUsed
    : [...current.wordsUsed, upper]

  const milestoneLexicographer =
    current.milestoneLexicographer || wordsUsed.length >= GLOBAL.masteryWordsRequired

  const milestoneLengthy =
    current.milestoneLengthy || upper.length >= 8

  const milestoneRaritySeeker =
    current.milestoneRaritySeeker || countRare(upper) >= 2

  const milestoneChainLink =
    current.milestoneChainLink || chainLength >= 3

  const milestoneSwift =
    current.milestoneSwift ||
    (timeSinceLastBurstSec != null && timeSinceLastBurstSec < GLOBAL.masterySwiftWindow)

  return {
    wordsUsed,
    milestoneLexicographer,
    milestoneLengthy,
    milestoneRaritySeeker,
    milestoneChainLink,
    milestoneSwift,
  }
}

export function isMasteryComplete(m: LetterMastery): boolean {
  return (
    m.milestoneLexicographer &&
    m.milestoneLengthy &&
    m.milestoneRaritySeeker &&
    m.milestoneChainLink &&
    m.milestoneSwift
  )
}
